import React, {useState} from 'react';
import Dashicon from '../icons/Dashicon';
import classNames from 'classnames';
import {I18N} from '../../globals/config';
import {TestResult} from '../TestResults';
import {getFix} from '../../api/ajax/test-results';
import {sanitize} from 'dompurify';

import styles from './item.pcss';


function getIcon( item: TestResult ) {
	switch ( item.result ) {
		case true:
			return ( <Dashicon icon="yes-alt" title={I18N.pass} /> );
		case false:
			return ( <Dashicon icon="warning" title={I18N.fail} /> );
		case null:
			return ( <Dashicon icon="editor-help" title={I18N.unknown} /> );
	}
	return null;
}

function getCleanId( item: TestResult ) {
	return item.testId.split( '\\' ).pop()?.toLowerCase();
}

type Props = {
	item: TestResult
}

const Item = ( {item}: Props ) => {
	const [ loading, setLoading ] = useState( false );

	const fixIssue = () => {
		setLoading( true );
		getFix( item.testId )
			.then( ( result: TestResult ) => {
				Object.assign( item, result );
				setLoading( false );
			} );
	};

	return (
		<div className={styles.wrap} id={`go-live-update-urls/test-results/${getCleanId( item )}`}>
			<div className={classNames( [ styles.label, styles.column ] )}>
				<h4>{item.label}</h4>
				<p
					className={classNames( {
						description: true,
						[ styles.message ]: true,
						[ styles.pass ]: true === item.result,
						[ styles.fail ]: false === item.result,
						[ styles.warning ]: null === item.result,
					} )}>
					{! loading &&
						<span dangerouslySetInnerHTML={{__html: sanitize( item.message )}} />}
				</p>
			</div>
			<div className={styles.column}>
				{! loading && item.fixAvailable && false === item.result && <button
					title={I18N.click_to_fix}
					onClick={fixIssue}
					data-jest={getCleanId( item )}
					className={styles.fix + ' button button-primary'}>
					{I18N.fix}
				</button>}
			</div>
			<div className={classNames( [ styles.icon, styles.column ] )}>
				{loading && <span className={styles.loading + ' spinner is-active'} />}
				{! loading && getIcon( item )}
			</div>

		</div>
	);
};

export default Item;
